module.exports = __webpack_public_path__ + "img/icon-share.4bf62be6.svg";